<template>
  <section
    class="gauge-container base-card"
    v-for="a in dominanceList"
    :key="a"
  >
    <header class="gauge-header-wrapper">
      <h5 class="title">
        {{ $t(a.label) }}<br /><span
          v-if="a.id === 'btc' || a.id === 'tether'"
          >{{ $t("menu-dropdown.dominance") }}</span
        >
      </h5>
      <!-- <h5 class="title">{{$t('menu-dropdown.dominance')}}</h5> -->
    </header>
    <article class="gauge-wrapper">
      <!-- <common-loading v-if="!isFetch" /> -->
      <div
        class="gauge-chart"
        autoresize
        :id="a.id"
        style="width: 100%; height: 100%"
      ></div>
    </article>
  </section>

  <!-- <div class="guage-wrapper">
        <div class="guage-container">
            <div :id="a.id" style="width: 100%; height: 400px;"></div>
        </div>
    </div> -->
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
import { getDominanceGuage } from "@/api/chart/dominanceChartApi";
import { GaugeChart } from "@/utils/charts/gauage_chart";

const dominanceList = ref([
  { id: "btc", value: 0, label: "chart2.bitcoinDominance" },
  { id: "tether", label: "chart2.tetherDominance", value: 0 },
  { id: "fixed", label: "chart2.domi3", value: 0 },
  { id: "fluctuating", label: "chart2.domi4", value: 0 },
]);
onMounted(async () => {
  let coinDominance = await getDominanceGuage();
  // console.log('coinDominance',coinDominance);

  let btc_dominance = Number(coinDominance.btc);
  let tether_dominance = Number(coinDominance.tether);
  let fixed_dominance = Number(coinDominance.fixed);
  let fluctuating_dominance = Number(coinDominance.fluctuating);
  dominanceList.value.find((el) => el.id == "btc").value = btc_dominance;
  dominanceList.value.find((el) => el.id == "tether").value = tether_dominance;
  dominanceList.value.find((el) => el.id == "fixed").value = fixed_dominance;
  dominanceList.value.find((el) => el.id == "fluctuating").value =
    fluctuating_dominance;
  // console.log(dominanceList.value);
  dominanceList.value.forEach((el) => setGuageChart(el.id, el.value));
});

function setGuageChart(id, value) {
  var chartDom = document.getElementById(id);
  var myChart = echarts.init(chartDom);
  var option;
  const gaugeChart = new GaugeChart();
  const seriesOptions = gaugeChart.getSeriseOpitons();

  if (id === "btc" || id === "tether") {
    seriesOptions.min = 0;
    seriesOptions.max = 100;
  } else {
    if (value > 100) seriesOptions.max = 200;
    else if (value < -100) seriesOptions.min = -200;
  }
  seriesOptions.data.push(value);
  // console.log('seriesOptions',seriesOptions);

  option = {
    series: seriesOptions,
  };
  option && myChart.setOption(option);
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/charts/gauge.scss";
</style>
